import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

const routes = [
    //首页
    {path: '/', name: '首页', meta: {login: 'home'}, component: () => import('../views/home')},
    //产品中心
    {
        path: '/product',
        name: '产品中心',
        redirect: {path: '/product/brand'},
        component: () => import('../views/product/product'),
        children: [
            {
                path: '/product/brand',
                name: '品牌产品',
                component: () => import('../views/product/brand'),
                meta: {
                    login: 'product',
                    cate: 'BRAND PRODUCTS',
                }
            },
            {
                path: '/product/moreProduct',
                name: '更多产品',
                component: () => import('../views/product/moreProduct'),
                meta: {
                    login: 'product',
                    cate: 'MORE PRODUCTS',
                }
            },
            {
                path: '/product/details',
                name: '产品详情',
                component: () => import('../views/product/Details'),
                meta: {
                    login: 'product',
                    cate: 'detais',
                }
            },
            {
                path: '/product/produceSearch',
                name: '产品搜索',
                component: () => import('../views/product/produceSearch'),
                meta: {
                    login: 'product',
                    cate: 'search',
                }
            },
        ]
    },
    //招贤纳士
    {
        path: '/recruit',
        name: '招贤纳士',
        meta: {login: 'recruit', cate: 'TALENTS WANTED',},
        component: () => import('../views/recruit')
    },
    //新闻中心
    {
        path: '/news',
        name: '新闻中心',
        meta: {login: 'news', cate: 'NEWS CENTER',},
        component: () => import('../views/news')
    },
    {
        path: '/newDetails',
        name: '新闻详情',
        meta: {login: 'news', cate: 'NEWS CENTER',},
        component: () => import('../views/newDetails')
    },
    {
        path: '/contactUs',
        name: '联系我们',
        meta: {login: 'contactUs', cate: 'CONTACT US',},
        component: () => import('../views/contactUs')
    },
    //关于升和
    {
        path: '/about',
        name: '关于升和',
        redirect: {path: '/about/CompanyProfile'},
        component: () => import('../views/About/about'),
        children: [
            {
                path: '/about/CompanyProfile',
                name: '公司简介',
                component: () => import('../views/About/CompanyProfile'),
                meta: {
                    login: 'about',
                    cate: 'COMPANY PROFILE',
                }
            },
            {
                path: '/about/EnterpriseHistory',
                name: '企业历程',
                component: () => import('../views/About/EnterpriseHistory'),
                meta: {
                    login: 'about',
                    cate: 'ENTERPRISE HISTORY',
                }
            },
            {
                path: '/about/qualification',
                name: '荣誉资质',
                component: () => import('../views/About/qualification'),
                meta: {
                    login: 'about',
                    cate: 'HONOR AND QUALIFICATION',
                }
            },
            {
                path: '/about/CulturalConcept',
                name: '文化理念',
                component: () => import('../views/About/CulturalConcept'),
                meta: {
                    login: 'about',
                    cate: 'CULTURAL CONCEPT',
                }
            },
        ]
    },
]

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)
    document.getElementsByTagName('title')[0].innerText = '升和药业-' + to.name
    next()
})

export default router;
